import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
import {
  Card,
  CardHeader,
  LinearProgress,
  Stack,
  Tooltip,
} from "@mui/material";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import MaterialTypography from "../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { allSalestargetdetails } from "./grphql";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import PageLoading from "../../components/Loading/PageLoading";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import EmployeeTargetList from "./employee/EmployeeTargetList";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import ManagerTargetTabel from "./manager/ManagerTargetTabel";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import TableComponent from "../../components/GridTable/TableComponent";

// function CustomPagination(props) {
//   return <GridPagination ActionsComponent={CustomPagination} {...props} />;
// }

const date = new Date();

const currentyear = date.getFullYear();
const PreviousYear = date.getFullYear() + 1;

const SalesTarget = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const columns = [
    { field: "sno", label: "S.No.", width: 30 },
    {
      field: "financialYear",
      label: "Financial Year",
      flex: 1,
    },
    {
      field: "target",
      label: "Target",
      flex: 1,
    },
    {
      field: "salesTeam",
      label: "Sales Team",
      flex: 1,
    },
    {
      field: "productCategory",
      label: "Product Category",
      flex: 1,
    },
    {
      field: "salesTerritory",
      label: "Sales Territory",
      flex: 1,
    },
    {
      field: "businessLine",
      label: "Business Line",
      flex: 1,
    },
    {
      field: "action",
      label: "Action",
      type: "number",
      flex: 1,

      renderCell: (params) => (
        <Stack direction="row" spacing={1} sx={{ marginRight: "10px" }}>
          <IconButton
            color="primary"
            sx={{ color: "#3F51B5d4" }}
            onClick={() => handleView(params.row.id)}
          >
            <VisibilityIcon />
          </IconButton>
          {params?.row?.array.length == 0 ? (
            <IconButton
              color="#3F51B5d4"
              sx={{ color: "#3F51B5d4" }}
              onClick={() => handleMonthlyTarget(params.row.id)}
            >
              <Tooltip title="Add Monthly Target">
                <TrackChangesIcon />
              </Tooltip>
            </IconButton>
          ) : (
            <IconButton
              color="primary"
              sx={{ color: "#3F51B5d4" }}
              onClick={() => handleUpdateMonthlyTarget(params.row.id)}
            >
              <Tooltip title="Update Monthly Target">
                <CrisisAlertIcon />
              </Tooltip>
            </IconButton>
          )}

          {/* <IconButton
            color="secondary"
            // onClick={() => handleDelete(params.row.id)}
          >
            <DeleteIcon />
          </IconButton> */}
        </Stack>
      ),
    },
  ];

  const handleUpdateMonthlyTarget = (id) => {
    navigate(`/SalesTarget/updateMonthlyTarget?${id}`);
  };
  const handleView = (id) => {
    navigate(`/SalesTarget/ViewMonthlyTarget?${id}`);
  };
  const handleMonthlyTarget = (id) => {
    navigate(`/SalesTarget/singlepersontarget?${id}`);
  };
  const rows = data.map((item, index) => ({
    sno: index + 1,
    id: item.id,
    financialYear: item.salesTarget.financialYear,
    target: item?.targetAmount,
    salesTeam: item?.user?.username,
    productCategory: "No",
    salesTerritory: "No",
    businessLine: "No",
    array: item?.monthlytargetSet,
    action: (
      <Stack direction="row" spacing={1} sx={{ marginRight: "10px" }}>
        <Tooltip title="View ">
        <IconButton
          color="primary"
          sx={{ color: "#3F51B5d4" }}
          onClick={() => handleView(item.id)}
        >
          <VisibilityIcon />
        </IconButton>
        </Tooltip>
        {item?.monthlytargetSet?.length == 0 ? (
          <IconButton
            color="#3F51B5d4"
            sx={{ color: "#3F51B5d4" }}
            onClick={() => handleMonthlyTarget(item.id)}
          >
            <Tooltip title="Add Monthly Target">
              <TrackChangesIcon />
            </Tooltip>
          </IconButton>
        ) : (
          <IconButton
            color="primary"
            sx={{ color: "#3F51B5d4" }}
            onClick={() => handleUpdateMonthlyTarget(item?.id)}
          >
            <Tooltip title="Update Monthly Target">
              <CrisisAlertIcon />
            </Tooltip>
          </IconButton>
        )}

        {/* <IconButton
      color="secondary"
      // onClick={() => handleDelete(params.row.id)}
    >
      <DeleteIcon />
    </IconButton> */}
      </Stack>
    ),
  }));

  const columnGroupingModel = [
    {
      groupId: "Basic info",
      children: [
        { field: "salesTeam" },
        { field: "productCategory" },
        { field: "salesTerritory" },
        { field: "businessLine" },
      ],
    },
  ];
  const { circleLoading, setCirleLoading } = useLoading();

  useEffect(() => {
    const fetchdata = async () => {
      setIsLoading(true);
      try {
        const res = await request(BASEURL, allSalestargetdetails);
        const status = res?.allSalestargetdetails?.some(
          (v) =>
            v?.salesTarget.financialYear == `${currentyear}-${PreviousYear}`
        );
        setButtonStatus(status);

        setData(res?.allSalestargetdetails);
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchdata();
  }, []);

  const handleNewTarget = () => {
    navigate("/SalesTarget/AddSalesTarget");
  };

  const handleViewTarget = () => {
    navigate("/SalesTarget/ViewYearlyTarget");
  };

  const onCheck=(list)=>
  {
      console.log("id-c",list)
  }
    
  const onDeleteALL=()=>
  {
      console.log("id-DELE")
  }

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

{isUser.toLowerCase() == "manager" && <ManagerTargetTabel />}
        {isUser.toLowerCase() == "employee" && <EmployeeTargetList />}
        {isUser.toLowerCase() == "superuser" && (
          <div style={{ height: 420, width: "100%" }}>
            
                  <TableComponent
                  tableLoading={isLoading ? true : false}
                  columns={columns}
                  rowsData={rows}
                  styles={{ paper: { padding: '16px' } }}
                  head="Sales Target List"
                  actions={false}
                  checked={false}
                  view={true}
                  showView={data?.length !== 0 && (true)}
                  showAdd =  {!buttonStatus && (true)}
                  onCheck={onCheck}
                  viewList={() => handleViewTarget()}
                  // onEdit={onContactListClick}
                  // onDelete={onDelete}
                  // onView={onContactListClick}
                  onDeleteALL={onDeleteALL}
                  addList={() => handleNewTarget()}
                  />
            {/* // <MaterialDataGrid rows={rows} columns={columns} /> */}
            
            {isLoading && <PageLoading />}
          </div>
        )}

      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Sales Target List
                </MaterialTypography>
              </Stack>
              {isUser.toLowerCase() == "superuser" && (
                <>
                  {!buttonStatus && (
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      // startIcon={<AddIcon />}
                      onClick={() => handleNewTarget()}
                    >
                      Add Yearly Target
                    </MaterialButton>
                  )}

                  {data?.length != 0 && (
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      // startIcon={<AddIcon />}
                      onClick={() => handleViewTarget()}
                    >
                      View Yearly Target
                    </MaterialButton>
                  )}
                </>
              )}
            </Stack>
          }
        />
        {isUser.toLowerCase() == "manager" && <ManagerTargetTabel />}
        {isUser.toLowerCase() == "employee" && <EmployeeTargetList />}
        {isUser.toLowerCase() == "superuser" && (
          <div style={{ height: 420, width: "100%" }}>
            {!isLoading && 
                  <TableComponent
                  columns={columns}
                  rowsData={rows}
                  styles={{ paper: { padding: '16px' } }}
                  head="Sales Target List"
                  actions={true}
                  checked={true}
                  view={true}
                  showView={data?.length !== 0 && (true)}
                  showAdd =  {!buttonStatus && (true)}
                  onCheck={onCheck}
                  viewList={() => handleViewTarget()}
                  // onEdit={onContactListClick}
                  // onDelete={onDelete}
                  // onView={onContactListClick}
                  onDeleteALL={onDeleteALL}
                  addList={() => handleNewTarget()}
                  />
            // <MaterialDataGrid rows={rows} columns={columns} />
            }
            {isLoading && <PageLoading />}
          </div>
        )}
      </Card> */}
    </DashboardLayout>
  );
};

export default SalesTarget;
